import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { format } from 'date-fns'

const initialFrom = () => {
    const d = new Date()
    d.setDate(1)
    d.setMonth(d.getMonth() - 1)
    return format(d, 'yyyyMMdd')
}

const initialTo = () => format(new Date(), 'yyyyMMdd')

const useMiunDateRange = () => {
    const [searchParams, setSearchParams] = useSearchParams()

    const from = useMemo(() => searchParams.get('from') || initialFrom(), [searchParams])
    const to = useMemo(() => searchParams.get('to') || initialTo(), [searchParams])

    const setRange = useCallback(
        (nextFrom: string, nextTo: string) => {
            setSearchParams(
                (prev) => {
                    const next = new URLSearchParams(prev)
                    next.set('from', nextFrom)
                    next.set('to', nextTo)
                    return next
                },
                { replace: true },
            )
        },
        [setSearchParams],
    )

    return { from, to, setRange }
}

export default useMiunDateRange
